import { Actions, createNamespace } from "../../../flux/Actions";
import { EntityType } from "../../../models/EntityType";

const ns = createNamespace('DeleteObjects');
export const names = {
    SET_IDS: ns('SET_IDS'),
    SHOW_CONFIRMATION: ns('SHOW_CONFIRMATION'),
    HIDE_CONFIRMATION: ns('HIDE_CONFIRMATION'),
    ERROR: ns('ERROR'),
};

export class DeleteObjectsActions extends Actions
{
    setIds = (ids: (number|string)[], meta: EntityType) => this.dispatch(names.SET_IDS, ids, meta);
    showConfirmation = (meta: EntityType) => this.dispatch(names.SHOW_CONFIRMATION, null, meta);
    hideConfirmation = (meta: EntityType) => this.dispatch(names.HIDE_CONFIRMATION, null, meta);
    showError = (error: Error, meta: EntityType) => this.dispatch(names.ERROR, error, meta);
}


// WEBPACK FOOTER //
// ./src/app/flux/DeleteObjects/DeleteObjectsActions.ts